export default "__VITE_ASSET__BRqHouod__"